import {gsap} from "gsap/all";
import $ from "jquery";
import {BaseGame} from '/js/app/base/BaseGame.js'
import FontFaceObserver from '../../libs/fontfaceobserver.js';
import {AudioPlaylist} from "./AudioPlaylist";
import {DotLottie} from "@lottiefiles/dotlottie-web"
import {SeveCommunication} from './SeveCommunication'

// Set the WASM URL
DotLottie.setWasmUrl("js/libs/dotlottie-player.wasm");

// Constructor
export class BaseGameMNS2 extends BaseGame {

  constructor(dataFile = 'data/data.json') {

    // Super constructor
    super(dataFile);

    // Screensaver
    this.stillThereTimeout = false;
    this.screensaverDelay = 45; // Time before app return to idle screen

    // Uptime
    this.upSince = Date.now();

    // Object class
    this.playlist = new AudioPlaylist();

    // Animation timeline
    this.currentTimeline = null;

    // MNS2 settings
    this.level = "level1";

    // MNS2 - Update game videos language on language flip
    $(document).on('i18nFlip i18nSet', (e) => this.updateSeveVideosSrc(e.lang));
    this.updateSeveVideosSrc(this.i18n.lang)

    // Used to hold te top tooltips animation and allows to stop it
    this.topTooltipTl = null;

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData(),
      this.loadData("data/global.json")
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Preload fonts
      return this.preloadFont();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Init animations using Lottie librarie
      return this.initLottieAnimations();
    }).then(() => {
      // Convert IMG to inline SVG
      return window.convertSVGToInline();
    }).then(() => {
      // Initiate OSC communication with Seve
      return this.initSeveCommunication();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").show().append("<div id='error'>Error: " + error.message + "</div>")
    });

  }

  initGame(defaultScreenId = 1) {
    this.initScreenSaver();
    this.goToScreen(defaultScreenId);
  }

  preloadFont() {
    const fonts = [
      new FontFaceObserver("Work Sans", {weight: 300}),
      new FontFaceObserver("Work Sans", {weight: 400}),
      new FontFaceObserver("Work Sans", {weight: 600}),
      new FontFaceObserver("Work Sans", {weight: 700}),
      // TODO: Add missing fonts? Remove unnecessary fonts
    ];

    // Load each observer, then return promise
    let observers = [];
    for (let i = 0; i < fonts.length; i++) {
      observers.push(fonts[i].load());
    }

    return Promise.all(observers);
  }

  initLottieAnimations() {
    return new Promise(resolve => {
      const animations = $(".lottie-animation");

      // Resolve now if there is no animation to load
      if (animations.length === 0) resolve();

      // Set a counter to resolve when all animations are loaded
      let loadedCount = 0;

      animations.each(async (i, el) => {
        // Init lottie player
        const src = $(el).data("path");
        const autoplay = $(el).data("autoplay");
        const embedImages = $(el).data("embed-images");
        const loop = $(el).data("loop");
        const dataOrSource = embedImages ? {data: await this.lottieEmbedImages(src)} : {src: src};
        const lottie = new DotLottie({
          canvas: el,
          loop: loop,
          autoplay: autoplay,
          renderConfig: {devicePixelRatio: 1},
          ...dataOrSource
        });
        $(el).data("lottie", lottie);

        // Resolve when all animation are loaded
        lottie.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === animations.length) resolve();
        })
      });
    });
  }

  initSeveCommunication() {
    return new Promise(resolve => {
      this.seveCommunication = new SeveCommunication(this.settings.osc.host, this.settings.osc.client_port, this.settings.osc.server_port, this.settings.osc.address);
      resolve();
    });
  }

  lottieAutoPlaybackForScreen(screenId) {

    // Stop all currently playing auto-playback animation
    $(".lottie-animation[data-auto-playback='true'].playing").each(function (i, el) {
      const lottie = $(el).data('lottie');
      lottie.stop();
      $(el).removeClass('playing');
    });

    // Play auto-playback animation in current screen
    $(`#screen-${screenId} .lottie-animation[data-auto-playback='true']`).each(function (i, el) {
      const lottie = $(el).data('lottie');
      lottie.play();
      lottie.setLoop(true);
      $(el).addClass('playing');
    });
  }

  // To be overridden in child class
  updateSeveVideosSrc(language, srcCTA = "", srcResult = "") {
    const lang = language.toUpperCase();
    $("#seve-video-cta").attr("src", srcCTA.replace("{{LANG}}", lang));
    if ($("#seve-video-cta").hasClass("is-playing")) $("#seve-video-cta").get(0).play()
    $("#seve-video-result").attr("src", srcResult.replace("{{LANG}}", lang));
    if ($("#seve-video-result").hasClass("is-playing")) $("#seve-video-result").get(0).play()
  }

  seveVideoPlayback(state) {
    const videos = [
      {
        selector: "#seve-video-cta",
        state: (state === "cta"),
      },
      {
        selector: "#seve-video-result",
        state: (state === "result"),
      }
    ]
    for (const video of videos) {
      const $video = $(video.selector);
      $video.toggle(video.state);
      $video.toggleClass("is-playing", video.state);
      if (video.state) {
        $video.get(0).play();
      } else {
        $video.get(0).pause();
        $video.get(0).currentTime = 0;
      }
    }
  }

  onButtonPressed(e) {
    console.log("onButtonPressed()");

    // Reset still there interval
    this.resetTimer();

    if (this.lockScreen) {
      return;
    }

    if (this.stillThereTimeout !== false) {
      this.closeStillThereModal();
      return;
    }

    // Action depending on screen
    if (this.currentScreen === this.seveCtaScreenID) {

      if ($("#seve-video-cta").hasClass("is-playing")) app.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_SFXseveenvoyee.mp3", 1, true)

      // Auto quit app
      this.killTimeline(this.currentTimeline);
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => this.reset(), 7)

      // Switch video
      this.seveVideoPlayback("result")
    }
  }

  async lottieEmbedImages(src) {
    async function imageUrlToBase64(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    }

    const dataBuffer = await fetch(src);
    const data = await dataBuffer.json();
    const basePath = src.substring(0, src.lastIndexOf('/')) + '/images/'

    for (let i = 0; i < data.assets.length; i++) {
      if (data.assets[i].p.endsWith(".png") || data.assets[i].p.endsWith(".jpg")) {
        data.assets[i].e = 1
        data.assets[i].p = await imageUrlToBase64(basePath + data.assets[i].p)
      }
    }

    return data;
  }

  goToScreen(screenId, callback = null, skipLockScreenCheck = false) {
    const $specifiedScreenEl = $(`#screen-${screenId}`);

    // If screen id is not found, try to find a corresponding element by appending the level string
    let screenIdToUse = screenId;
    if ($specifiedScreenEl.length === 0) {
      const $levelScreenEl = $($(`[id^='screen-${screenId}']`).get().find((el) => el.id.includes(this.level.toUpperCase())));
      if ($levelScreenEl.length > 0) screenIdToUse = $levelScreenEl.attr("id").replace("screen-", "");
    }

    if (screenId === 2) this.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_INT_SFXstart.mp3", 1, true)

    super.goToScreen(screenIdToUse, callback, skipLockScreenCheck);
  }

  goToScreenSaver() {

    if ($("#still-there").hasClass("active")) {
      return false;
    }

    $("#still-there").addClass("active");
    this.openStillThereModal();
    this.stillThereTimeout = setTimeout(() => {
      this.reset(1);
      this.closeStillThereModal();
    }, 10000);
  }

  // Show overlay/modal popup
  toggleTooltip(visibility, tooltipId = null) {
    const $tooltips = visibility ? $(`.tooltip[data-tooltip-id="${tooltipId}"]`) : $(`.tooltip.shown`);
    const settings = {
      ease: "sine.in",
      duration: 0.25
    }

    if ($tooltips.length > 0) {
      gsap.to($tooltips.find("> .inner"), {
        y: (visibility) ? 0 : -50,
        ...settings
      })
      gsap.to($tooltips, {
        autoAlpha: (visibility) ? 1 : 0,
        ...settings
      })
      $tooltips.toggleClass("shown", visibility);
    }

    if (visibility) {
      return new Promise((resolve) => {
        $tooltips.find(".close").one(this.touchEvent, resolve);
      })
    }
  }

  // Close overlay/modal popup
  closeTooltip() {
    this.toggleTooltip(false)
  }

  // Handle per screen handcoachs and top tooltip
  showScreenTopTooltip(screenId, delay = 0) {

    this.killTimeline(this.topTooltipTl)
    this.topTooltipTl = gsap.timeline({delay: delay})

    const $tooltips = $("#screen-" + screenId).find(".top-tooltip");
    const screenHasTooltip = $tooltips.length > 0;

    if ($tooltips.hasClass("shown")) {
      console.log("Tooltip already shown, skip showScreenTopTooltip()");
      return;
    }

    if (screenHasTooltip) {

      this.topTooltipTl.add(() => {
        $tooltips.addClass("shown");
        $tooltips.addClass("animating");
      });
      this.topTooltipTl.to($tooltips.find(".wrapper"), {
        y: 0,
        autoAlpha: 1,
        duration: 1,
        immediateRender: false,
        onComplete: () => {
          $tooltips.removeClass("animating");
        }
      })
    }

    const $handcoaches = $("#screen-" + screenId).find(".handcoach:not(.excluded)");
    const screenHasHandcoaches = $handcoaches.length > 0;
    if (screenHasHandcoaches) {
      this.topTooltipTl.fromTo($handcoaches, {
        autoAlpha: 0,
        scale: 0.8,
      }, {
        autoAlpha: 1,
        scale: 1,
        duration: 1,
        immediateRender: false,
        onStart: function () {
          const lottie = $(".lottie-animation", this.targets()).data('lottie');
          lottie.stop();
          lottie.play();
        }
      })
    }

    if (screenHasHandcoaches || screenHasTooltip) {
      $(document).one((this.isTouch ? 'touchstart touchmove' : 'mousedown'), (e) => {
        this.hideScreenTopTooltip(e)
      })
    }

  }

  // Handle per screen handcoachs and top tooltip
  hideScreenTopTooltip(e) {

    this.killTimeline(this.topTooltipTl)
    this.topTooltipTl = gsap.timeline()

    const $tooltips = $(".screen.current").find(".top-tooltip");
    const screenHasTooltip = $tooltips.length > 0;
    if (screenHasTooltip) {
      $tooltips.removeClass("shown");
      $tooltips.addClass("animating");
      this.topTooltipTl.to($tooltips.find(".wrapper"), {
        y: -$tooltips.find(".inner").outerHeight(),
        duration: 1,
        onComplete: () => {
          $tooltips.removeClass("animating");
        }
      }, 0)
    }

    const $handcoaches = $(".screen.current").find(".handcoach");
    const screenHasHandcoaches = $handcoaches.length > 0;
    if (screenHasHandcoaches) {
      this.topTooltipTl.to($handcoaches, {
        autoAlpha: 0,
        scale: 0.8,
        onComplete: function () {
          $(".lottie-animation", this.targets()).data('lottie').stop();
        }
      }, 0)
    }
  }

  toggleScreenTopTooltip() {
    const $tooltips = $(".screen.current").find(".top-tooltip");
    if ($tooltips.hasClass("animating")) return;
    if ($tooltips.hasClass("shown")) {
      this.hideScreenTopTooltip();
    } else {
      this.showScreenTopTooltip(this.currentScreen);
    }
  }

  setAdditionalToolsVisibility(showHome = true, showHelp = false) {
    const additionalToolsEls = $("#additional-tools > div");

    if (showHome) {
      gsap.to(additionalToolsEls.filter('[data-action=reset]'), {opacity: 1, duration: 0.3});
      additionalToolsEls.css("pointer-events", "all");
    } else {
      gsap.to(additionalToolsEls.filter('[data-action=reset]'), {opacity: 0.5, duration: 0.3});
      additionalToolsEls.css("pointer-events", "none");
    }

    if (additionalToolsEls.not('[data-action=reset]').length > 0) {
      if (showHelp) {
        gsap.to(additionalToolsEls.not('[data-action=reset]'), {y: 0, duration: 0.3});
      } else {
        gsap.to(additionalToolsEls.not('[data-action=reset]'), {y: 150, duration: 0.3});
      }
    }
  }

  helpTrigger() {
    this.toggleScreenTopTooltip(this.currentScreen)
  }

  selectLevel(level) {
    this.level = level;
    $(".level-choice").removeClass("active")
    $(".level-choice." + level).addClass("active")
    $("#select-level-button").addClass("enabled")
    this.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_INT_SFXselection.mp3", 1, true)

    // Level selector has a lottie animation
    // if ($(`.level-choice.${level} canvas`).length > 0) {
    //   const lottie = $(`.level-choice.${level} canvas`).data("lottie");
    //   lottie.setFrame(0)
    //   lottie.play()
    // }
  }

  openStillThereModal() {
    const tl = gsap.timeline();

    tl.to($("#still-there"), {
      duration: 0.5,
      autoAlpha: 1
    });

    tl.fromTo($("#still-there .modal"), {
      autoAlpha: 0,
      y: "-10px",
    }, {
      duration: 0.5,
      autoAlpha: 1,
      y: 0,
    });

    tl.fromTo($("#still-there .modal .progress"), {
      width: "100%",
    }, {
      duration: 10,
      width: 0,
      ease: 'none',
    }, 0);
  }

  closeStillThereModal() {

    if (this.stillThereTimeout != false) {
      clearTimeout(this.stillThereTimeout);
      this.stillThereTimeout = false;
    }

    gsap.to($("#still-there"), 0.5, {
      autoAlpha: 0,
      onComplete: function () {
        $("#still-there").removeClass("active");
      }
    });
  }

  // Kill/reset timeline before building a new one
  killTimeline(timeline) {
    BaseGameMNS2.killTimeline(timeline);
  }

  static killTimeline(timeline) {
    if (timeline) {
      timeline.kill();
      timeline = null;
    }
  }

  // Reset values when we return to the homepage
  reset(screenId, resetCallback) {

    if (typeof screenId == "undefined") {
      screenId = 1;
    }

    this.closeStillThereModal();

    // Reset levels
    this.level = "level1";
    $("#select-level-button").removeClass("enabled")
    $(".level-choice").removeClass("active")

    // Hide any courent top tooltip
    this.hideScreenTopTooltip()

    // Return to idle screen
    this.i18n.setWithFlip('fr')
    this.goToScreen(screenId, () => {
      resetCallback();
      $(".top-tooltip").removeClass("shown animating")
      this.audio.clearAll()
    }, true);

  }
}
